



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import CreateBookingDateRequest from '@/models/BookingDates/CreateBookingDateRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'BookingDateCreate'
})
export default class extends GiganautVueDialog {

  dialog = false;
  date ='';
  //bookingRoles: SelectableEntity<BookingRoleDto>[] = [];
  // selectedBookingRoleIds: string[] = [];
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.date = '';
      // this.bookingRoles =  BookingDetailsModule.currentBooking.roles.map(function(bookingRole) {
      //   return new SelectableEntity<BookingRoleDto>(bookingRole);
      // });
    }
  }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  // async updateSelectedBookingRoles(val: boolean, bookingRole: BookingRoleDto) {
  //   	if (val) {
	// 		  this.selectedBookingRoleIds.push(bookingRole.id);
	// 	} else {
	// 		  var index = this.selectedBookingRoleIds.indexOf(bookingRole.id);
  //       this.selectedBookingRoleIds.splice(index, 1); 
	// 	}
	// }
	  
  async save() {  
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateBookingDateRequest();
    request.date = new Date(`${this.date}T12:00`)
    //request.bookingRoleIds = this.selectedBookingRoleIds;
    await BookingDetailsModule.createBookingDate(request);
    this.dialog = false;
  }
}
